import { render, staticRenderFns } from "./knowledge-trend.vue?vue&type=template&id=32aef1db&scoped=true"
import script from "./knowledge-trend.vue?vue&type=script&lang=js"
export * from "./knowledge-trend.vue?vue&type=script&lang=js"
import style0 from "./knowledge-trend.vue?vue&type=style&index=0&id=32aef1db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aef1db",
  null
  
)

export default component.exports